//
// LayoutContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseUIModel";

var LayoutContext = createModule("commons::LayoutContext", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    ,
    {
        invertXSpace: 2,
        ignoreContainerPadding: 2,
        positionTiledContentRelativeToRoot: 2,
        tileGap: 5,
        enableTileMinimums: 2,
        scrollBarSize: 5,
        enableTileReflow: 2,
        designWidth: 4,
        handleScrollBarSpace: 2,
        defaultMinimumHeight: 5,
        invertYSpace: 2,
        containerInset: 5,
        reserveSpaceForMinimum: 2,
        disableRecursion: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LayoutContext;
